// "On this page" section menu (/pillars/, /free-training-plans/) —
// highlights the section in view and keeps that link scrolled into
// the (sideways-scrolling) track on phones. Also publishes the site header's height as
// --gg-nav-h on every page, so sticky bars and rails (this menu, the
// essay Contents rail) dock directly beneath it.

export default function sectionNav() {
    const header = document.querySelector(".gg-nav");
    const setOffset = () => {
        if (header) {
            document.documentElement.style.setProperty("--gg-nav-h", `${header.offsetHeight}px`);
        }
    };
    setOffset();
    window.addEventListener("resize", setOffset, { passive: true });

    const nav = document.querySelector("[data-section-nav]");
    if (!nav) return;

    const links = [...nav.querySelectorAll('a[href^="#"]')];
    const track = nav.querySelector(".gg-section-nav__track");
    const sections = links
        .map((link) => document.getElementById(link.hash.slice(1)))
        .filter(Boolean);
    if (!sections.length || !("IntersectionObserver" in window)) return;

    const setActive = (id) => {
        links.forEach((link) => {
            const on = link.hash === `#${id}`;
            link.classList.toggle("is-active", on);
            if (on) {
                link.setAttribute("aria-current", "location");
                if (track) {
                    const left = link.offsetLeft - (track.clientWidth - link.offsetWidth) / 2;
                    track.scrollTo({ left, behavior: "smooth" });
                }
            } else {
                link.removeAttribute("aria-current");
            }
        });
    };

    // A section counts as "current" once it crosses the upper
    // third of the viewport.
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) setActive(entry.target.id);
            });
        },
        { rootMargin: "-30% 0px -65% 0px" }
    );
    sections.forEach((section) => observer.observe(section));
}
